export default __webpack_public_path__ + "static/media/gps.8bba25c6.png";